import {Component} from 'react';
import {browserHistory} from 'react-router';

export default class PageContainer extends Component {
    openPage(url) {
        browserHistory.push(url);
    }
    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/page-container.js